// extracted by mini-css-extract-plugin
export var connectionButton = "_48-1";
export var rightPanel = "_48-3";
export var stepDescription = "_48-2";
export var stepIcon = "_48-0";